import api from '@/api';

export default {
  sentStatus: function (sentstatusRequest: sentstatus.SentStatusRequest): Promise<sentstatus.SentStatusResponse> {
    return api.post({
      url: '/cubelook/sentstatus/api/getstatus',
      data: sentstatusRequest
    });
  },
};
